import Forms from ".";

export const formRoutes = (data) => [
  {
    path: "/admin/forms",
    title: "plans",
    layout: "admin",
    routeType: "admin",
    component: Forms,
  },
];
